import React from 'react';
import { FormProvider, Controller } from 'react-hook-form';
import ReactSwitch from 'react-switch';
import { ModalHeader, ModalBody, ModalFooter } from '@/components/common/Modal/types';
import { ReactComponent as InformationIcon } from '@/assets/icons/ri-information-line.svg'
import Button from '@/components/common/Button';
import Input from '@/components/common/Input';
import {CUSTOMER_STATUS} from "@/pages/Customers/constant";
import { ReactComponent as AlertIcon } from '@/assets/icons/ri-alert-line.svg';
import {GENERAL_STATUS_STYLE} from "@/constant/status";

export const renderCustomerFormHeader: ModalHeader = {
	title: 'Add/Edit Customer'
}
export const renderCustomerFormBody = ({ customerMethods }, customerId, submitModal): ModalBody => ({
	children: (
		<FormProvider {...customerMethods}>
			<form onSubmit={customerMethods.handleSubmit(submitModal)} className="flex flex-col items-start pt-3 px-8 gap-4">
				<Input expanded name="name" type="text" label="Name" placeholder="Fill Name" {...customerMethods.register('name')}/>
				<Input expanded name="phoneNumber" type="text" label="No. HP" placeholder="e.g +62812345678990" {...customerMethods.register('phoneNumber')}/>
				<Input expanded name="email" type="email" label="Email" placeholder='e.g yourname@yourmail.com' {...customerMethods.register('email')}/>
				<div className="flex justify-between gap-5 w-full">
					<div className="flex gap-3 p-0 items-center">
						<p className="text-grey-dark">
							<InformationIcon/>
						</p>
						<p className="font-bold">Status</p>
					</div>
					<Controller
						name="status"
						render={({ field }) =>
							<select
								className={`color-select ${GENERAL_STATUS_STYLE[customerMethods.watch('status')]}`}
								placeholder="Select status"
								{...field}
							>
								{
									CUSTOMER_STATUS.map(i =>
										<option
											key={i}
											value={i}
											className={GENERAL_STATUS_STYLE[i]}>
											{i}
										</option>
									)
								}
							</select>
						}
					/>
				</div>
				{ customerId !== "" && 
				<div className="flex w-full justify-between pt-6 border-t border-t-grey-line-subtle items-end">
					<div className='flex flex-col flex-grow'>
						<label className="input__label" htmlFor="isBlocked">
							Invoice Overdue
						</label>
						<div className="text-jsm text-grey-dark font-normal">Customer has invoice overdue</div>
					</div>
					{customerMethods.getValues('isInvoiceOverdue') ? 
						<p className='text-red-primary bg-red-primary bg-opacity-10 px-4 py-1  h-8 rounded flex justify-between'><AlertIcon/> Yes</p> :
						<p className='bg-green-subtle text-green-success bg-opacity-10 px-4 py-1 h-8 rounded'>No</p>
					}
				</div>
				}
				{ customerId !== "" && 
				<div className="input__container w-full pb-6">
					<div className="flex w-full justify-between">
						<div className="flex flex-col flex-grow">
							<label className="input__label" htmlFor="isBlocked">
								Block
							</label>
							<div className="text-jsm text-grey-dark font-normal">Block this customer</div>
						</div>
						<Controller
							render={({field}) =>
							<ReactSwitch
								checked={field.value}
								uncheckedIcon={null}
								checkedIcon={null}
								offColor="#D0D2D8"
								onColor="#EE1D23"
								required={false}
								{...field} />}
							name="isBlocked"
						/>
					</div>
					<textarea
						className='w-full input__box p-4'
						name='blockedNote' 
						aria-label='Block reason'
						placeholder='Why this customer got blocked?'
						rows={2}
						{...customerMethods.register('blockedNote')}
					/>
				</div>
				}
				
			</form>
		</FormProvider>
	),
	data: { value: { id: customerId } }
})
export const renderCustomerFormFooter = (closeModal, submitModal) : ModalFooter => ({
	children: (
		<div className="flex justify-between items-center w-full p-8 gap-3">
			<Button type="button" variant="basic" onClick={closeModal()}>Decline</Button>
			<Button type="submit" variant="primary" onClick={submitModal()}>Save</Button>
		</div>
	)
})
